const scholarLinks = [
  { 
    name: "ÜNİS", 
    url: "https://unis.ahievran.edu.tr/akademisyen/memduh.kose",
    icon: "🏛️"
  },
  { 
    name: "Google Scholar", 
    url: "https://scholar.google.com/citations?user=TDghxaoAAAAJ&hl=tr&oi=sra",
    icon: "🔬"
  },
  { 
    name: "YÖK Akademik", 
    url: "https://akademik.yok.gov.tr/AkademikArama/view/viewAuthor.jsp",
    icon: "📚"
  },
  { 
    name: "Web of Science", 
    url: "https://www.webofscience.com/wos/author/record/Y-1085-2019",
    icon: "🌐"
  },
  { 
    name: "Scopus", 
    url: "https://www.scopus.com/authid/detail.uri?authorId=57214366788",
    icon: "📊"
  },
  { 
    name: "ORCID", 
    url: "https://orcid.org/0000-0002-4935-4542",
    icon: "🆔"
  }
];

export default scholarLinks;

